module.exports = [{
      plugin: require('/home/manument/htdocs/manument.com/releases/2026-10-20-12-53-37-main/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/manument/htdocs/manument.com/releases/2026-10-20-12-53-37-main/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
